import React, { useState } from 'react';

import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';

import MediaRoasStatisticsGraph from './MediaRoasStatisticsGraph';

const MediaRoasStatistics = () => {
  const [initialization, setInitialization] = useState(false);

  const initParams = {
    pltfomTpCode: 'all',
  };
  const [params, setParams] = useState(initParams);

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParams);
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          params={params}
          getParam={getParam}
          useDate={false}
          useDisplayFilter={false}
          useExternalFilter={false}
        />
      </NewFilterWrap>
      <MediaRoasStatisticsGraph params={params} />
    </>
  );
};

export default MediaRoasStatistics;
